import React from 'react';

import Heading from 'elements/typography/heading';
import { StyledSection } from './FAQSection.styles';
import FAQList from './FAQList';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  title: string;
  faqItems: FAQItem[];
}

const FAQSection = ({ title, faqItems }: FAQSectionProps): JSX.Element => {
  return (
    <StyledSection>
      <Heading text={title} size="3.375rem" align="center"/>
      <FAQList faqItems={faqItems} />
    </StyledSection>
  );
};

export default FAQSection;
